module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="image-properties">\n    <fieldset>\n        <legend class="collapsible collapsed" data-toggle="collapse" data-target=".image-properties-accordion">\n            Image Library\n        </legend>\n        <div class="image-properties-accordion collapse collapse-target images"></div>\n    </fieldset>\n</div>\n\n<div class="action-properties"></div>\n<div class="analytics-properties"></div>\n<div class="animation-properties"></div>\n<div class="style-properties"></div>\n<div class="size-and-position-properties"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/imageWidget/ImageWidgetPropertiesView.tpl
// module id = 1789
// module chunks = 0